"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var defaults_1 = __importDefault(require("../../defaults"));

var builder_1 = require("../../builder");

var ConfigurationKeys;

(function (ConfigurationKeys) {
  ConfigurationKeys["SelectedTrough"] = "selectedTrough";
  ConfigurationKeys["WashBasinDimension"] = "washBasinDimension";
  ConfigurationKeys["ApronBackSplash"] = "apronBackSplash";
  ConfigurationKeys["BuiltInParts"] = "builtInParts";
  ConfigurationKeys["Surface"] = "surface";
  ConfigurationKeys["AssemblyAccessories"] = "assemblyAccessories";
  ConfigurationKeys["DrainAccessories"] = "drainAccessories";
})(ConfigurationKeys = exports.ConfigurationKeys || (exports.ConfigurationKeys = {}));

var Configuration =
/** @class */
function () {
  function Configuration(props, plateBuilder) {
    var _this = this;

    this.hasTowelRail = function () {
      return _this.builtInParts && _this.builtInParts.towelRail;
    };

    this.hasCutOutAtIndex = function (index) {
      return _this.builtInParts && _this.builtInParts.cutOutDisposalsPosition && _this.builtInParts.cutOutDisposalsPosition.length > 0 && _this.builtInParts.cutOutDisposalsPosition[index];
    };

    this.hasPaperTowelAtIndex = function (index) {
      return _this.builtInParts && _this.builtInParts.paperTowelDispensersPosition && _this.builtInParts.paperTowelDispensersPosition.length > 0 && _this.builtInParts.paperTowelDispensersPosition[index];
    };

    this.hasTissueDispenserAtIndex = function (index) {
      return _this.builtInParts && _this.builtInParts.tissueDispenser && _this.builtInParts.tissueDispenserPosition && _this.builtInParts.tissueDispenserPosition.length > 0 && _this.builtInParts.tissueDispenserPosition[index];
    }; // It looks like, creating a new DrainAccessories might actually reset all the defaults since they reside in props? Hmm...


    if (typeof props.configuration !== 'undefined') {
      props = props;
      this.props = props.configuration;
      this.prevDefaults = props.prevDefaults;
    } else {
      props = props;
      this.props = props;
      this.prevDefaults = props.defaults;
    }

    if (!plateBuilder) {
      plateBuilder = this.trough && new builder_1.PlateBuilder(this, this.trough);
    }

    this.plateBuilder = plateBuilder;
  }
  /**
   * Takes the configuration Data and returns the set of Data's by given key.
   */


  Configuration.prototype.data = function () {
    var _this = this;

    var data = {};
    Object.keys(ConfigurationKeys).forEach(function (key) {
      var _a;

      return lodash_1.assign(data, (_a = {}, _a[ConfigurationKeys[key]] = _this[ConfigurationKeys[key]], _a));
    });
    return data;
  };
  /**
   * Returns the configuration Object by previously given key.
   */


  Configuration.prototype.dataByKey = function () {
    if (!this.key) {
      return;
    }

    return this.render && this.render[this.key]();
  };
  /**
   *
   * @param instance {string} Key of Main Configuration item
   * @param key {string} Key of Sub Configuration item
   */


  Configuration.prototype.getDefault = function (instance, key) {
    if (!this.key || !this.default || this.default && !this.default[key]) {
      return defaults_1.default[instance][key];
    }

    return this.default[key];
  };

  Configuration.prototype.handle = function () {
    return null;
  };

  Configuration.prototype.handleDefaults = function () {
    return;
  };

  Configuration.prototype.render = function () {
    var _a;

    return this.key && lodash_1.assign({}, this.props, (_a = {}, _a[this.key] = this.handle(), _a));
  };

  Object.defineProperty(Configuration.prototype, "apronBackSplash", {
    /**
     * Returns the data set for apron and back splash
     */
    get: function get() {
      return this.props.apronBackSplash;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "assemblyAccessories", {
    /**
     * Returns the data set for the assembly accessories
     */
    get: function get() {
      return this.props.assemblyAccessories;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "builtInParts", {
    /**
     * Returns the data set for the assembly accessories
     */
    get: function get() {
      return this.props.builtInParts;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "drainAccessories", {
    /**
     * Returns a new instance of the trough dependency calculation
    get calculator(): ConfCalculator | undefined {
      if (!this.trough) {
        return;
      }
      return new ConfCalculator(this.props, this.trough, this.reset);
    }
     */

    /**
     * Returns the data set for the drain accessories
     */
    get: function get() {
      return this.props.drainAccessories;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "default", {
    get: function get() {
      return this.key && this.defaults[this.key];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "defaults", {
    get: function get() {
      var confDefaults = this.props.defaults; // We can disable stuff here, but changing the values is not reliable... since on change, the handleDefaults takes over, kind of weird... need to refactor really

      if (this.isVariusMedRwt) {
        confDefaults.builtInParts.tapHole = lodash_1.assign({}, defaults_1.default.builtInParts.tapHole, {
          default: false,
          values: [false]
        });
        confDefaults.builtInParts.soapDispenserHole = lodash_1.assign({}, defaults_1.default.builtInParts.soapDispenserHole, {
          default: 'without',
          values: ['without']
        });
        confDefaults.builtInParts.tissueDispenser = lodash_1.assign({}, defaults_1.default.builtInParts.tissueDispenser, {
          default: false,
          values: [false]
        });
        confDefaults.builtInParts.towelRail = lodash_1.assign({}, defaults_1.default.builtInParts.towelRail, {
          default: false,
          values: [false]
        });
        confDefaults.assemblyAccessories.console = lodash_1.assign({}, defaults_1.default.assemblyAccessories.console, {
          default: 'miranit',
          values: ['miranit']
        });
      }

      if (!this.isVariusMedRwt && this.isVariusMed) {
        confDefaults.assemblyAccessories.console = lodash_1.assign({}, defaults_1.default.assemblyAccessories.console, {
          default: 'miranit'
        });
      }

      if (this.isVariusMed) {
        confDefaults.surface.color = lodash_1.assign({}, defaults_1.default.surface.color, {
          default: 'white',
          values: ['white']
        });
        confDefaults.surface.gelCoat.default = true;
      }

      var updatedValues = defaults_1.default.builtInParts.soapDispenserHole.values;

      if (this.trough && typeof this.trough.allowedPartSD80 !== 'undefined' && !this.trough.allowedPartSD80) {
        updatedValues = updatedValues.filter(function (v) {
          return v !== 'SD80';
        });
      }

      if (this.trough && typeof this.trough.allowedPartSDOthers !== 'undefined' && !this.trough.allowedPartSDOthers) {
        updatedValues = updatedValues.filter(function (v) {
          return v !== 'others';
        });
      }

      confDefaults.builtInParts.soapDispenserHole = lodash_1.assign({}, defaults_1.default.builtInParts.soapDispenserHole, {
        default: 'without',
        values: updatedValues
      });

      if (this.trough && this.drainAccessories) {// confDefaults.drainAccessories.drain = validateDrain(this.drainAccessories, confDefaults.drainAccessories, this.trough, this).drain;
      }

      return confDefaults;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "hasLeftCorner", {
    get: function get() {
      return this.washBasinDimension && this.washBasinDimension.cornerDesignPosition && this.washBasinDimension.cornerDesignPosition.indexOf('left') > -1 || false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "hasRightCorner", {
    get: function get() {
      return this.washBasinDimension && this.washBasinDimension.cornerDesignPosition && this.washBasinDimension.cornerDesignPosition.indexOf('right') > -1 || false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "hasLeftWall", {
    get: function get() {
      return this.washBasinDimension && this.washBasinDimension.typeOfInstallation && (this.washBasinDimension.typeOfInstallation === 'left' || this.washBasinDimension.typeOfInstallation === 'with') || false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "hasRightWall", {
    get: function get() {
      return this.washBasinDimension && this.washBasinDimension.typeOfInstallation && (this.washBasinDimension.typeOfInstallation === 'right' || this.washBasinDimension.typeOfInstallation === 'with') || false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "hasApron", {
    get: function get() {
      return this.apronBackSplash && this.apronBackSplash.apron === 'with' && this.apronBackSplash.apronHeight ? true : false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "hasAlteredLeftAngle", {
    get: function get() {
      if (!this.washBasinDimension || this.washBasinDimension.typeOfInstallation === 'right' || this.washBasinDimension.typeOfInstallation === 'without') {
        return false;
      }

      var index = this.washBasinDimension.typeOfInstallation === 'left' ? 0 : 0;
      return this.washBasinDimension.angleOfNiche && typeof this.washBasinDimension.angleOfNiche[index] !== 'undefined' && this.washBasinDimension.angleOfNiche[index] !== 90 || false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "hasAlteredRightAngle", {
    get: function get() {
      if (!this.washBasinDimension || this.washBasinDimension.typeOfInstallation === 'left' || this.washBasinDimension.typeOfInstallation === 'without') {
        return false;
      }

      var index = this.washBasinDimension.typeOfInstallation === 'right' ? 0 : 1;
      return this.washBasinDimension.angleOfNiche && typeof this.washBasinDimension.angleOfNiche[index] !== 'undefined' && this.washBasinDimension.angleOfNiche[index] !== 90 || false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "isNewWashBasinDimensions", {
    get: function get() {
      var prev = this.prevDefaults && this.prevDefaults.washBasinDimension;
      var current = this.washBasinDimension;
      return JSON.stringify(prev) !== JSON.stringify(current);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "isNewTrough", {
    get: function get() {
      var prevTroughId = this.prevDefaults && this.prevDefaults.selectedTrough && this.prevDefaults.selectedTrough.troughId;
      return this.props.troughId !== prevTroughId ? true : false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "isNewCornerDesign", {
    get: function get() {
      var prevCornerDesign = this.prevDefaults && this.prevDefaults.washBasinDimension && this.prevDefaults.washBasinDimension.cornerDesign.default;
      return prevCornerDesign !== (this.washBasinDimension && this.washBasinDimension.cornerDesign) ? true : false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "isNewCornerDesignPosition", {
    get: function get() {
      var prevPosition = this.prevDefaults && this.prevDefaults.washBasinDimension.cornerDesignPosition.default;
      var cornerDesign = this.washBasinDimension && this.washBasinDimension.cornerDesign;
      var cornerDesignPosition = this.washBasinDimension && this.washBasinDimension.cornerDesignPosition;

      if (cornerDesign === 'none') {
        return false;
      }

      return (prevPosition && prevPosition.length) !== (cornerDesignPosition && cornerDesignPosition.length) ? true : false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "isNewQty", {
    get: function get() {
      var prevQty = this.prevDefaults && this.prevDefaults.selectedTrough && this.prevDefaults.selectedTrough.qty ? this.prevDefaults.selectedTrough.qty : this.qty;
      return prevQty !== this.qty ? true : false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "isNewPlateWidth", {
    get: function get() {
      var prevPlateWidth = this.prevDefaults && this.prevDefaults.washBasinDimension && this.prevDefaults.washBasinDimension.plateWidth && this.prevDefaults.washBasinDimension.plateWidth.current;
      return prevPlateWidth !== (this.washBasinDimension && this.washBasinDimension.plateWidth) ? true : false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "isNewTypeOfInstallation", {
    get: function get() {
      var prevTypeOfInstallation = this.prevDefaults && this.prevDefaults.washBasinDimension && this.prevDefaults.washBasinDimension.typeOfInstallation.default;
      var typeOfInstallation = this.washBasinDimension && this.washBasinDimension.typeOfInstallation;
      return prevTypeOfInstallation !== typeOfInstallation ? true : false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "isNewApron", {
    get: function get() {
      var prevApron = this.prevDefaults && this.prevDefaults.apronBackSplash && this.prevDefaults.apronBackSplash.apron.default;
      var apron = this.apronBackSplash && this.apronBackSplash.apron;
      return prevApron && apron && prevApron !== apron ? true : false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "isMedcare", {
    get: function get() {
      return this.trough && this.trough.fileName.includes('MEDCARE') ? true : false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "isVariusMed", {
    get: function get() {
      return this.trough && this.trough.variusmed ? true : false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "isExos", {
    get: function get() {
      return this.trough && this.trough.exos ? true : false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "isNewVariusMed", {
    get: function get() {
      return this.isNewTrough && this.isVariusMed;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "isVariusMedRwt", {
    get: function get() {
      return this.props.troughId === '5beead053f4e3673bfa65fa7' ? true : false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "isNewVariusMedRwt", {
    get: function get() {
      return this.isNewTrough && this.isVariusMedRwt;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "isVariusMedMzb", {
    get: function get() {
      return this.props.troughId === '5beeadac3f4e3673bfa65fa8' ? true : false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "isVariusParis", {
    get: function get() {
      return this.props.troughId === '5beea0df3f4e3673bfa65f98' ? true : false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "isNewVariusMedMzb", {
    get: function get() {
      return this.isNewTrough && this.isVariusMedMzb;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "isWithOverflow", {
    get: function get() {
      return this.trough && this.trough.overflowWith || false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "prevQty", {
    get: function get() {
      return this.prevDefaults && this.prevDefaults.selectedTrough && this.prevDefaults.selectedTrough.qty || this.qty;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "qty", {
    get: function get() {
      return this.selectedTrough && this.selectedTrough.qty ? this.selectedTrough.qty : 1;
    },
    set: function set(value) {
      if (this.selectedTrough) {
        this.selectedTrough.qty = value;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "reset", {
    get: function get() {
      return this.isNewTrough || this.isNewQty ? true : false;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "resetDistances", {
    get: function get() {
      return this.isNewTrough || this.isNewTypeOfInstallation || this.isNewCornerDesignPosition || this.isNewCornerDesign || this.reset;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "sapNumber", {
    get: function get() {
      return this.props.sapNumber;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "selectedTrough", {
    get: function get() {
      return this.props.selectedTrough;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "selectedConsole", {
    get: function get() {
      var fallback = this.isVariusMed ? 'miranit' : 'stainlessSteel';
      return this.assemblyAccessories && this.assemblyAccessories.console ? this.assemblyAccessories.console : fallback;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "surface", {
    get: function get() {
      return this.props.surface;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "trough", {
    get: function get() {
      var trough = this.selectedTrough && this.selectedTrough.trough;

      if (!trough) {
        return;
      }

      return trough;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "washBasinDimension", {
    get: function get() {
      return this.props.washBasinDimension;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "setKey", {
    set: function set(key) {
      this.key = key;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "setPrevKey", {
    set: function set(key) {
      this.prevKey = key;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "setProps", {
    // Setting props could cause a problem for our plateBuilder class, however I dont think its used... commenting out to confirm
    set: function set(props) {
      this.props = props;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "getProps", {
    get: function get() {
      return this.props;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Configuration.prototype, "setPrevDefaults", {
    set: function set(props) {
      this.prevDefaults = props.prevDefaults;
    },
    enumerable: true,
    configurable: true
  });
  return Configuration;
}();

exports.Configuration = Configuration;